export type StoreCategory =
  | "Верхняя одежда"
  | "Трикотаж"
  | "Топы"
  | "Брюки"
  | "Обувь";

export type StoreAudience = "Женское" | "Мужское" | "Унисекс";

export type StoreVariant = {
  size: string;
  stock: number;
};

export type StoreProduct = {
  id: string;
  sku: string;
  name: string;
  brand: string;
  category: StoreCategory;
  audience: StoreAudience;
  price: number;
  oldPrice?: number;
  image: string;
  gallery?: string[];
  color: string;
  colorHex: string;
  sizes: string[];
  variants: StoreVariant[];
  material: string;
  stock: number;
  rating: number;
  reviews: number;
  badge?: string;
  description: string;
  fit: string;
  care: string;
  published: boolean;
};

export type StoreOrderStatus =
  | "Новый"
  | "Подтверждён"
  | "Собирается"
  | "Передан в доставку"
  | "Завершён"
  | "Отменён";

export type StoreOrder = {
  id: string;
  createdAt: string;
  customer: string;
  email: string;
  phone: string;
  city: string;
  address: string;
  delivery: "courier" | "pickup";
  payment: "card" | "on-receipt";
  paymentStatus: "Тестовая авторизация" | "При получении";
  subtotal: number;
  deliveryCost: number;
  total: number;
  items: Array<{
    productId: string;
    sku: string;
    name: string;
    size: string;
    quantity: number;
    price: number;
  }>;
  status: StoreOrderStatus;
  source: "Сайт";
};

export type StoreBanner = {
  id: string;
  eyebrow: string;
  title: string;
  text: string;
  cta: string;
  image: string;
  tone: "ink" | "paper";
  category?: StoreCategory;
};

export type StoreAnalytics = {
  sessions: number;
  productViews: number;
  addToCart: number;
  checkouts: number;
  orders: number;
  revenue: number;
};

export type StoreCustomer = {
  name: string;
  email: string;
  phone: string;
  city: string;
  address: string;
};

export type StoreState = {
  products: StoreProduct[];
  orders: StoreOrder[];
  banners: StoreBanner[];
  analytics: StoreAnalytics;
  customer: StoreCustomer;
  updatedAt: string;
  revision: number;
};

export type StoreBootstrap = StoreState & {
  csrfToken: string;
  sandboxId: string;
};

export const emptyStoreState: StoreState = {
  products: [],
  orders: [],
  banners: [],
  analytics: {
    sessions: 0,
    productViews: 0,
    addToCart: 0,
    checkouts: 0,
    orders: 0,
    revenue: 0,
  },
  customer: {
    name: "",
    email: "",
    phone: "",
    city: "",
    address: "",
  },
  updatedAt: "",
  revision: 0,
};

export const storeCategories = [
  {
    name: "Верхняя одежда",
    description: "Пальто и технологичные слои",
    image: "/assets/vanta/look-13.jpg",
  },
  {
    name: "Трикотаж",
    description: "Водолазки и мягкая база",
    image: "/assets/vanta/look-07.jpg",
  },
  {
    name: "Топы",
    description: "Майки, сетка и сложный крой",
    image: "/assets/vanta/look-06.jpg",
  },
  {
    name: "Брюки",
    description: "Деним, карго и широкий силуэт",
    image: "/assets/vanta/look-04.jpg",
  },
  {
    name: "Обувь",
    description: "Пары для городского ритма",
    image: "/assets/vanta/look-11.jpg",
  },
] as const;
